<template>
  <main class="main programmazione-siae max-width">
    <article>
  		<h1 class="title-medium centered regular">Registrazione effettuata</h1>
      <p>La registrazione ha avuto esito positivo. Controlla la tua casella email per attivare il tuo profilo su Edizioni Caramba! Attenzione: se non hai ricevuto la mail, attendi qualche minuto, oppure prova a controllare la sezione "spam" della tua casella email</p>
    </article>
  </main>
</template>

<script>
export default {
  mounted() {
    document.title = 'Caramba - Registrazione effettuata';
  }
}
</script>




// WEBPACK FOOTER //
// src/vue/components/SignupSuccess.vue